import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { useTasks } from "../hooks";
import { TaskItem } from "./task-item";

interface IProps {
  customerId?: number;
}

export const TasksList: React.FC<IProps> = ({ customerId }) => {
  const { data, loading, refetch } = useTasks({
    where: customerId ? { customerId } : {},
  });

  if (loading) return <Loading />;

  if (!data?.tasks?.results?.length) {
    return <EmptyList text="Aucune tâche" />;
  }

  return (
    <div>
      {data.tasks.results.map((task) => (
        <TaskItem
          key={`task-${task.id}`}
          task={task}
          showOwner
          onChanged={() => refetch()}
        />
      ))}
    </div>
  );
};
